"use client";
import React, { useEffect, useState } from "react";
import { TopicResponse } from "@/types/common";
import { CustomPagination } from "@/components/ui/CustomPagination";
import { pageService } from "@/services/pageServices";
import { TrendingCard } from "@/components/Card/TrendingCard";
import Loader from "@/components/Loader";
import { useScrollRef } from "@/context/ScrollContext";

const TagsContent = ({
  tag,
  subTag = "",
  host,
}: {
  tag: string | undefined;
  subTag?: string;
  host: string;
}) => {
  const [topicsData, setTopicsData] = useState<TopicResponse | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isPageChanging, setIsPageChanging] = useState(false);
  const [pageSize] = useState(10);
  const scrollRef = useScrollRef();

  

  const fetchData = async (page: number) => {
    setIsPageChanging(true);
    setIsLoading(true)
    try {
      const temp =
    tag + `?pageSize=${pageSize}&pageNo=${page}&tags=${subTag}`;
      const response = await pageService.getTopicsBySlug(temp || "", host);
      setTopicsData(response.data);
      setTotalPages(response.data?.pagination?.totalPages || 1);
      setCurrentPage(response.data?.pagination?.currentPage || 1);
      scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });

    } catch (error) {
      console.error("Error fetching topics:", error);
    } finally {
      setIsPageChanging(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const handlePageChange = async (page: number) => {
    setCurrentPage(page);
  };

  if (isLoading) return <Loader />

  return (
    <>
      <div className="max-w-7xl mx-auto w-full">
        {/* <h1 className="text-5xl md:text-7xl font-medium capitalize mb-8 md:mb-16 line-clamp-1 truncate overflow-hidden text-ellipsis"> */}
        <h1 className="text-5xl md:text-7xl font-medium capitalize mb-8 md:mb-16">
          {topicsData?.topic.name}
          <span className="text-orange">.</span>
        </h1>
        <div className="w-full md:w-[70%] grid grid-cols-1 gap-6">
          {topicsData?.posts.map((post, index) => (
            
              <TrendingCard
                key={`article-${index}`}
                data={post}
                hoverStyle="default"
                imageSize="xlarge"
                imageStyle={"rounded"}
                layout={"horizontal"}
                wantDescription={false}
                titleSize="medium"
                description="small"
                className="lg:w-20 lg:h-20 w-16 h-16"
                descriptionSize="small"
                isVideo={post.isVideo?.toString()}
                title="normal"
              />
            
          ))}
        </div>
        <CustomPagination
          className="mt-8"
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          isLoading={isPageChanging}
        />
      </div>
    </>
  );
};

export default TagsContent;
